(function (app, ng) {

    app.component("paginationControls",
        {
            templateUrl: "App/Components/PaginationControls/pagination-controls.component.html",
            controller: paginationControlsController,
            bindings: {
                setThisPage: "&",
                pager: "<"
            }
        });

    paginationControlsController.$inject = [];
    function paginationControlsController() {
        const $ctrl = this;

        ng.extend($ctrl, {
            setPage: setPage
        });

        function setPage(compValue) {
            $ctrl.setThisPage({ callBackValue: compValue });
        }
    }

})(window.app, window.angular); // jshint ignore:line